import { ComponentProps, forwardRef } from 'react'
import { BottomSheet as RSBottomSheet } from 'react-spring-bottom-sheet'
import type { BottomSheetRef } from 'react-spring-bottom-sheet'

type BottomSheetProps = {
  children: React.ReactNode
  open: boolean
  onDismiss?: () => void
  setOpen: (open: boolean) => void
} & ComponentProps<typeof RSBottomSheet>

const BottomSheet = (
  {
    children,
    open,
    onDismiss,
    setOpen,
    ...originBottomSheetProps
  }: BottomSheetProps,
  ref?: React.Ref<BottomSheetRef>,
) => {
  return (
    <RSBottomSheet
      initialFocusRef={false}
      open={open}
      onDismiss={() => {
        setOpen(false)
        onDismiss?.()
      }}
      ref={ref}
      {...originBottomSheetProps}>
      {children}
    </RSBottomSheet>
  )
}

export default forwardRef(BottomSheet)
